module.exports = __webpack_public_path__ + "img/dong1.6cb4b903.gif";